import { Plural, Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconVisibility from '@/icons/Visibility.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const NewSupervisorAssignmentBulkNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'new_supervisor_assignment_bulk'>;
}) => {
  const { t } = useLingui();

  const { authorName, count } = notification.data;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.new-supervisor-assignment-bulk.label',
        message: `You have been assigned as the supervisor of ${count} requests by ${authorName}`,
      })}
      icon={<IconVisibility on />}
      type="new"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.new-supervisor-assignment-bulk">
          You have been assigned as the supervisor of {count}{' '}
          <Plural value={count} one="request" other="requests" /> by{' '}
          <InlineText weight="medium" color={color}>
            {authorName}
          </InlineText>
        </Trans>
      )}
      notificationHref="/requests?assignedToMe=true"
    />
  );
};
